import { updated } from "../actions";

export const updateTodo = (todoId, todotext) => {
    return async dispatch => {
        const response = await fetch("https://lws-server.herokuapp.com/todos/"+ todoId, {
            method: "PATCH",
            body: JSON.stringify({
                text: todotext
            }),
            headers: {
                "Content-type" : "application/json; charset=UTF-8"
            }
        });

        const todo = await response.json();

        dispatch(updated(todo.id, todo.text));
    };
};